export default __webpack_public_path__ + "static/media/ysd-004-setu_01.020615bb.jpg";